import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { usePermissions } from '../../hooks/usePermissions';
import { DISPLAY_PERMISSIONS, PERMISSION_LABELS } from '../../constants/permissions';

export default function PermissionsCheckboxList({ form, name = 'permissions', userPermissions = [], disabled = false }) {
  const { permissions: currentUserPermissions, isSuperuser } = usePermissions();

  // Определяем какие чекбоксы должны быть disabled
  const getIsDisabled = (permission) => {
    if (disabled) return true;
    if (isSuperuser) return false;

    // Если у текущего пользователя нет этого полномочия - disabled
    const hasPermission = currentUserPermissions.some((p) => p.name === permission || p === permission);
    return !hasPermission;
  };

  // Инициализируем значения формы на основе userPermissions
  useEffect(() => {
    if (userPermissions && userPermissions.length > 0) {
      const permissionValues = {};
      DISPLAY_PERMISSIONS.forEach((permission) => {
        permissionValues[permission] = userPermissions.some((p) => p.name === permission || p === permission);
      });
      form.setValue(name, permissionValues);
    }
  }, [userPermissions, form, name]);

  return (
    <div className="space-y-3">
      <p className="text-sm font-medium text-gray-700 mb-2">Полномочия пользователя</p>
      {DISPLAY_PERMISSIONS.map((permission) => (
        <div key={permission} className="relative flex gap-x-3">
          <div className="flex h-6 items-center">
            <Controller
              control={form.control}
              name={`${name}.${permission}`}
              render={({ field: { onChange, value, ...rest } }) => (
                <input
                  type="checkbox"
                  id={permission}
                  checked={value || false}
                  onChange={(e) => onChange(e.target.checked)}
                  disabled={getIsDisabled(permission)}
                  className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  {...rest}
                />
              )}
            />
          </div>
          <div className="text-sm leading-6">
            <label htmlFor={permission} className={`font-medium ${getIsDisabled(permission) ? 'text-gray-400' : 'text-gray-900'}`}>
              {PERMISSION_LABELS[permission]}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
}
